<div class="detail-kpi-row" [attr.data-testid]="testId || null">
    <app-detail-kpi-card *ngFor="let c of cards"
                         [card]="c"
                         (linkClicked)="onLink($event)">
    </app-detail-kpi-card>
</div>
